/**
 * @enum SharedId
 *
 * Represents **shared translation or resource identifiers** that are
 * not tied to a specific UI component or page.
 *
 * Each enum key defines a semantic, lowercase identifier that groups
 * reusable data or translations used across multiple parts of the app.
 *
 * Typical use cases include:
 * - Loading general-purpose translations (e.g., currencies, countries)
 * - Centralizing platform-wide labels or constants
 * - Maintaining consistency across unrelated UI elements and pages
 *
 * Example:
 * ```ts
 * import { SharedId } from '@ts/enums/SharedId'
 * import { useTranslator } from '@wicadu/reina-pepiada/hooks'
 *
 * const t = getTranslation(`ui-${SharedId.Currencies}`, {})
 * <p>t?.usd</p>
 * // -> 'United States Dollars'
 * ```
 */
export enum SharedId {
  Seo = 'seo'
}
